import { render, staticRenderFns } from "./errorsCorrectionTab.vue?vue&type=template&id=2a604140&scoped=true&"
import script from "./errorsCorrectionTab.vue?vue&type=script&lang=js&"
export * from "./errorsCorrectionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a604140",
  null
  
)

export default component.exports